import React from 'react'
import { FieldValues, FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { DevTool } from '@hookform/devtools'
import noop from 'lodash/noop'

import { FormProps } from './form.types.ts'

export const Form = <FormValues extends FieldValues>({
  children,
  onSubmit,
  name,
  initialValues,
  validationSchema,
}: React.PropsWithChildren<FormProps<FormValues>>): React.ReactElement => {
  const methods = useForm<FormValues>({
    mode: 'onChange',
    defaultValues: initialValues,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    resolver: validationSchema && yupResolver(validationSchema),
  })

  const { handleSubmit, control } = methods

  return (
    <FormProvider<FormValues> {...methods}>
      <form
        onSubmit={(event) => {
          // на случай вложенных форм
          event.stopPropagation()
          handleSubmit(onSubmit ?? noop)(event)
        }}
        name={name}
        aria-label={name}
        id={name}
      >
        {children}
      </form>
      {process.env.NODE_ENV === 'development' && <DevTool control={control} />}
    </FormProvider>
  )
}
